/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Tin3Inputs */



/**

* @param {Validation_Tin3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const validation_tin3 = /** @type {((inputs?: Validation_Tin3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Tin3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Die 11-stellige Steuer ID ist ungültig.")
});
export { validation_tin3 as "validation_TIN" }